import { createInternalLogger, defaultBatchingConfig, defaultGlobalObjectKey, defaultInternalLoggerLevel, defaultUnpatchedConsole, isObject, } from '@grafana/faro-core';
import { defaultEventDomain } from '../consts';
import { parseStacktrace } from '../instrumentations';
import { fetchUserSession, isUserSessionValid } from '../instrumentations/session';
import { createSession, defaultMetas, defaultViewMeta } from '../metas';
import { k6Meta } from '../metas/k6';
import { FetchTransport } from '../transports';
import { getWebInstrumentations } from './getWebInstrumentations';
export function makeCoreConfig(browserConfig) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const transports = [];
    const internalLogger = createInternalLogger(browserConfig.unpatchedConsole, browserConfig.internalLoggerLevel);
    if (browserConfig.transports) {
        if (browserConfig.url || browserConfig.apiKey) {
            internalLogger.error('if "transports" is defined, "url" and "apiKey" should not be defined');
        }
        transports.push(...browserConfig.transports);
    }
    else if (browserConfig.url) {
        transports.push(new FetchTransport({
            url: browserConfig.url,
            apiKey: browserConfig.apiKey,
        }));
    }
    else {
        internalLogger.error('either "url" or "transports" must be defined');
    }
    function createMetas() {
        const initialMetas = defaultMetas;
        if (browserConfig.metas) {
            initialMetas.push(...browserConfig.metas);
        }
        const isK6BrowserSession = isObject(window.k6);
        if (isK6BrowserSession) {
            return [...initialMetas, k6Meta];
        }
        return initialMetas;
    }
    return {
        app: browserConfig.app,
        batching: Object.assign(Object.assign({}, defaultBatchingConfig), browserConfig.batching),
        dedupe: (_a = browserConfig.dedupe) !== null && _a !== void 0 ? _a : true,
        globalObjectKey: browserConfig.globalObjectKey || defaultGlobalObjectKey,
        instrumentations: (_b = browserConfig.instrumentations) !== null && _b !== void 0 ? _b : getWebInstrumentations(),
        internalLoggerLevel: (_c = browserConfig.internalLoggerLevel) !== null && _c !== void 0 ? _c : defaultInternalLoggerLevel,
        isolate: (_d = browserConfig.isolate) !== null && _d !== void 0 ? _d : false,
        metas: createMetas(),
        parseStacktrace,
        paused: (_e = browserConfig.paused) !== null && _e !== void 0 ? _e : false,
        preventGlobalExposure: (_f = browserConfig.preventGlobalExposure) !== null && _f !== void 0 ? _f : false,
        transports,
        unpatchedConsole: (_g = browserConfig.unpatchedConsole) !== null && _g !== void 0 ? _g : defaultUnpatchedConsole,
        beforeSend: browserConfig.beforeSend,
        eventDomain: (_h = browserConfig.eventDomain) !== null && _h !== void 0 ? _h : defaultEventDomain,
        ignoreErrors: browserConfig.ignoreErrors,
        // The new session management feature is a PoC and still under development and IS NOT READY for any production use!
        experimentalSessions: Object.assign({ 
            // TODO: will be true on release
            enabled: false, persistent: false, session: createSessionMeta() }, browserConfig.experimentalSessions),
        // TODO: deprecate/remove old init code or maybe rename to legacy_session?
        session: (_j = browserConfig.session) !== null && _j !== void 0 ? _j : createSession(),
        user: browserConfig.user,
        view: (_k = browserConfig.view) !== null && _k !== void 0 ? _k : defaultViewMeta,
    };
}
function createSessionMeta() {
    const userSession = fetchUserSession();
    const sessionId = isUserSessionValid(userSession) ? userSession === null || userSession === void 0 ? void 0 : userSession.sessionId : createSession().id;
    return {
        id: sessionId,
    };
}
//# sourceMappingURL=makeCoreConfig.js.map